export const colors = {
  black: "#000000E6",
  gray: "#666666",
  gray2: "#90949A",
  red: "#E8505B",
  black2: "#3A3A3A",
};

export const tabPillBackgroundColors = {
  Open: "#FFF4EB",
  Hold: "#CCE6FF",
  Allocated: "#F9F5FF",
  QC: "#F7FDFA",
  Recommended: "#FEF5F8",
  Submitted: "#F1F2FF",
  Rejected: "#E6FBFE",
  Closed: "#F5D1D3",
  Reassigned: "#FFF4A4",
  "Case Approval": "#FFF4EB",
  "Invoice Approval": "#CCE6FF",
  "Hospital De-Empanelment": "#F9F5FF",
  "Garage De-Empanelment": "#F7FDFA",
  "Police Complaints": "#FEF5F8",
  "Vendor Approval": "#F1F2FF",
  "Claim Number": "#F9F5FF",
  "Exclusion List": "#CCE6FF",
  "Cautions Tagging": "#F9F5FF",
  "Policy Number": "#F9F5FF",
};
export const tabPillColors = {
  Open: "#FE9551",
  Hold: "#0084FF",
  Allocated: "#A760FF",
  QC: "#59CE8F",
  Recommended: "#F56D91",
  Submitted: "#396AF2",
  Rejected: "#28C3D8",
  Closed: "#CE1821",
  Reassigned: "#A2A52D",
  "Case Approval": "#FE9551",
  "Invoice Approval": "#0084FF",
  "Hospital De-Empanelment": "#A760FF",
  "Garage De-Empanelment": "#59CE8F",
  "Police Complaints": "#F56D91",
  "Vendor Approval": "#396AF2",
  "Claim Number": "#A760FF",
  "Exclusion List": "#0084FF",
  "Cautions Tagging": "#A760FF",
  "Policy Number": "#A760FF",
};
export const activeTabBgColor = {
  Open: "#FF9551",
  Hold: "#0084FF",
  Allocated: "#A55FFC",
  QC: "#59CE8F",
  Recommended: "#F56D91",
  Submitted: "#396AF2",
  Rejected: "#28C3D8",
  Closed: "#CE1821",
  Reassigned: "#ABA112",
  "Case Approval": "#FF9551",
  "Invoice Approval": "#0084FF",
  "Hospital De-Empanelment": "#A55FFC",
  "Garage De-Empanelment": "#59CE8F",
  "Police Complaints": "#F56D91",
  "Vendor Approval": "#396AF2",
  "Claim Number": "#A55FFC",
  "Exclusion List": "#F4AC84",
  "Cautions Tagging": "#A55FFC",
  "Policy Number": "#A55FFC",
};
export const vendorTabStyles = [
  {
    label: "rejected",
    color: "#991F01",
    bgColor: "#FFD6CC",
    border: "1px solid #991F01",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    padding: "0.8rem 3rem",
  },
  {
    label: "reinvestigated",
    color: "#991F01",
    bgColor: "#FFD6CC",
    border: "1px solid #991F01",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    padding: "0.8rem 3rem",
  },
  {
    label: "approved",
    color: "#0C7436",
    bgColor: "#C5F5D9",
    border: "1px solid #0C7436",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    padding: "0.8rem 3rem",
  },
  {
    label: "pending",
    color: "#3A3A3A",
    bgColor: "#FFFFFF",
    border: "1px solid #3A3A3A",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    padding: "0.8rem 3rem",
  },
  {
    label: "review",
    color: "#3A3A3A",
    bgColor: "#FFFFFF",
    border: "1px solid #3A3A3A",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    padding: "0.8rem 3rem",
  },
];
// export const investigationFirstTab = [
//   {
//     label: "Vendor & Blocks",
//     border: "1px solid #90949A",
//     activeBorderColor: "1px solid #E8505B",
//   },
//   {
//     label: "Investigation Reports",
//     border: "1px solid #90949A",
//     activeBorderColor: "1px solid #E8505B",
//   },
//   {
//     label: "Invoice",
//     border: "1px solid #90949A",
//     activeBorderColor: "1px solid #E8505B",
//   },
// ];
